import React from "react";
import { Row, Col } from "react-bootstrap";

export default function AboutSectionSubsection1({
  src,
  title,
  bodycopy,
  rowreverse,
  id,
  bodycopy2,
  bodycopy3,
}) {
  return (
    <Row
      id={id}
      className={`${
        rowreverse
          ? "rowreverse align-items-center justify-content-between about-container rowreversemob"
          : "rowreversemob align-items-center justify-content-between about-container"
      } `}
    >
      <Col md={7}>
        <div className="mt-md-0 mt-3">
          <h3 className="title mb-3">{title}</h3>
          <p className="mb-2">{bodycopy} </p>

          {bodycopy2 && (
            <>
              <p className="mb-1">
                <b>Pollination Services: </b> ApisChain provides essential
                pollination services to farmers, helping to enhance the
                yield of crops and improve honey production.
              </p>
              <p className="mb-0">
                <b>CF Services: </b> ApisChain provides Honey Contract Farming
                Services to honey manufacturers through the approved network of
                beekeepers (Eco-entrepreneur), ensuring a consistent supply of
                high-quality honey.
              </p>
              <p className="mb-0">
                <b>CM Services: </b> Contract Manufacturing Services offered by
                Apischain provide brands with a comprehensive solution for
                producing high-quality products without the need for large-scale
                manufacturing infrastructure.
              </p>
              <p className="mb-0">
                <b>Migration Services: </b> Colonies Migration Services provided
                by Apischain offer beekeepers a seamless solution for relocating
                their bee colonies to optimal locations for pollination and
                honey production.
              </p>

              <p className="mb-0">
                <b>Monetizing Services: </b> ApisChain offers eco-entrepreneurs
                a unique service that monetizes farming capacity by managing the
                eco-bee of other investors and eco-contributors.
              </p>
              <p className="mb-0">
                <b>Adoptable Eco-Bee Services: </b> ApisChain offers honey
                bees as an adoptable asset opportunity for eco-contributors,
                allowing them to adopt bee colonies.
              </p>
            </>
          )}

          {bodycopy3 && (
            <>
              <p className="mb-1">
                <b>Organic Honey: </b> Chemical preservative free and traceable
                honey.
              </p>
              <p className="mb-0">
                <b>ApisChain: </b> Streamlining honey supply chain.
              </p>
            </>
          )}
        </div>
      </Col>
      <Col md={4}>
        <img src={src} className="w-100" alt="about-images" />
      </Col>
    </Row>
  );
}
